module.exports = __webpack_public_path__ + "static/better-employee-02-540w-408ef1d1912395bd71ddf947e2727d4f.jpg";